export default __webpack_public_path__ + "static/media/odic.78363f5f.png";